// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2tjkJ","paramInput":"JobSimulator_paramInput__172x4","input":"JobSimulator_input__1TkMZ"};